// extracted by mini-css-extract-plugin
module.exports = {"clarificationHistoryWrap":"ClarificationHistory_clarificationHistoryWrap__2sbGu","historyList":"ClarificationHistory_historyList__1Tnqs"};